export default __webpack_public_path__ + "static/media/48.473d5a31.svg";